module.exports = __webpack_public_path__ + "img/1-15.413a1707.png";